var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M33 9H34V7H33V9ZM2 7H1V9H2V7ZM33 7H2V9H33V7Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M33 3H34V1H33V3ZM2 1H1V3H2V1ZM33 1H2V3H33V1Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M33 15H34V13H33V15ZM2 13H1V15H2V13ZM33 13H2V15H33V13Z","fill":"currentColor","key":2}),React.createElement("path",{"d":"M33 21H34V19H33V21ZM2 19H1V21H2V19ZM33 19H2V21H33V19Z","fill":"currentColor","key":3})]);
}

Menu.defaultProps = {"width":"35","height":"22","viewBox":"0 0 35 22"};

module.exports = Menu;

Menu.default = Menu;
